"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfValidateUpcomingShiftsResultDto = instanceOfValidateUpcomingShiftsResultDto;
exports.ValidateUpcomingShiftsResultDtoFromJSON = ValidateUpcomingShiftsResultDtoFromJSON;
exports.ValidateUpcomingShiftsResultDtoFromJSONTyped = ValidateUpcomingShiftsResultDtoFromJSONTyped;
exports.ValidateUpcomingShiftsResultDtoToJSON = ValidateUpcomingShiftsResultDtoToJSON;
exports.ValidateUpcomingShiftsResultDtoToJSONTyped = ValidateUpcomingShiftsResultDtoToJSONTyped;
const ShiftValidationResult_1 = require("./ShiftValidationResult");
/**
 * Check if a given object implements the ValidateUpcomingShiftsResultDto interface.
 */
function instanceOfValidateUpcomingShiftsResultDto(value) {
    if (!('totalShiftsChecked' in value) || value['totalShiftsChecked'] === undefined)
        return false;
    if (!('shiftAssignmentsRemoved' in value) || value['shiftAssignmentsRemoved'] === undefined)
        return false;
    if (!('orientationAssignmentsRemoved' in value) || value['orientationAssignmentsRemoved'] === undefined)
        return false;
    if (!('shifts' in value) || value['shifts'] === undefined)
        return false;
    return true;
}
function ValidateUpcomingShiftsResultDtoFromJSON(json) {
    return ValidateUpcomingShiftsResultDtoFromJSONTyped(json, false);
}
function ValidateUpcomingShiftsResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalShiftsChecked': json['totalShiftsChecked'],
        'shiftAssignmentsRemoved': json['shiftAssignmentsRemoved'],
        'orientationAssignmentsRemoved': json['orientationAssignmentsRemoved'],
        'shifts': (json['shifts'].map(ShiftValidationResult_1.ShiftValidationResultFromJSON)),
    };
}
function ValidateUpcomingShiftsResultDtoToJSON(json) {
    return ValidateUpcomingShiftsResultDtoToJSONTyped(json, false);
}
function ValidateUpcomingShiftsResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalShiftsChecked': value['totalShiftsChecked'],
        'shiftAssignmentsRemoved': value['shiftAssignmentsRemoved'],
        'orientationAssignmentsRemoved': value['orientationAssignmentsRemoved'],
        'shifts': (value['shifts'].map(ShiftValidationResult_1.ShiftValidationResultToJSON)),
    };
}
//# sourceMappingURL=ValidateUpcomingShiftsResultDto.js.map